import { Characteristic } from 'enums/characteristic';
import { NutriScoreCategory } from 'enums/nutriScoreCategory';
import * as AllergenList from 'types/Ingredient/Detail/AllergenList';
import * as BaseIngredientCategoryList from 'types/Ingredient/Detail/BaseIngredientCategoryList';
import * as CarbonDioxideList from 'types/Ingredient/Detail/CarbonDioxideList';
import * as NutrientList from 'types/Ingredient/Detail/NutrientList';
import * as SeasonList from 'types/Ingredient/Detail/SeasonList';
import * as TagList from 'types/Ingredient/Detail/TagList';
import * as UnitWeightList from 'types/Ingredient/Detail/UnitWeightList';

export type Type = {
	allergens: AllergenList.Type;
	calories: number | null;
	carbonDioxide: CarbonDioxideList.Type;
	categories: BaseIngredientCategoryList.Type;
	characteristic: Characteristic;
	density: number;
	hasNutriScore: boolean;
	id: string | null;
	name: string;
	nutriScoreCategory: NutriScoreCategory | null;
	nutriScoreCategoryIsSetByUser: boolean;
	nutrientValues: NutrientList.Type;
	scalingFactor: number;
	seasons: SeasonList.Type;
	source: string | null;
	tags: TagList.Type;
	unitWeights: UnitWeightList.Type;
};

export function create(): Type {
	return {
		allergens: AllergenList.create(),
		calories: null,
		carbonDioxide: CarbonDioxideList.create(),
		categories: BaseIngredientCategoryList.create(),
		characteristic: Characteristic.SolidQuantifiable,
		density: 0,
		hasNutriScore: false,
		id: null,
		name: '',
		nutriScoreCategory: null,
		nutriScoreCategoryIsSetByUser: false,
		nutrientValues: NutrientList.create(),
		scalingFactor: 0,
		seasons: SeasonList.create(),
		source: null,
		tags: TagList.create(),
		unitWeights: UnitWeightList.create(),
	};
}
